"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBucketMetricsConfigurationsInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContinuationToken: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "continuation-token"
        }
    }
};
//# sourceMappingURL=ListBucketMetricsConfigurationsInput.js.map